








import Vue from "vue";
import SignupForm from "@/components/Login/SignupForm.vue";
import { SignupCredentials } from "vue/types/vue";
import { UserService } from "../services";
import { AxiosResponse } from "axios";

export default Vue.extend({
  data() {
    return {
      loading: false,
      showSignupMessage: "",
      success: false
    };
  },
  components: { SignupForm },
  methods: {
    signup: async function (payload: SignupCredentials) {
      let signupMessage = "";
      let signup = {} as AxiosResponse;
      try {
        this.loading = true;
        signup = await UserService.userSignup(payload);
        if (signup.status === 201) {
          signupMessage = `Registrering lyckades`;
        } else if (signup.status === 400) {
          signupMessage = `Registrering misslyckades. ${signup.data}`;
        } else {
          throw `Okänt fel`;
        }
      } catch (error: any) {
        console.log("ERR", error);
        signupMessage = `Registrering misslyckades: ${error.data.message}`;
      } finally {
        this.success = signup.status === 201;
        this.loading = false;
        this.showSignupMessage = signupMessage;
      }
    },
    confirmSignup: function (confirm: boolean): void {
      this.showSignupMessage = "";
      if (confirm) {
        this.$router.push({ name: "login" }).catch(() => { });
      }
    },

    test: function (event: Event): void {
      console.log(event);
    }
  }
});
